module.exports = __webpack_public_path__ + "0ed72f4f5d14a442f65f35b49231c315.pdf";